import {ref} from 'vue';

export default {
    install: (app, options) => {
        const invoiceCompanies = ref([]);
        const invoiceTypes = ref([]);
        const invoiceStatuses = ref([]);

        const loadInvoicesParameters = () => {
            window.lazy_axios.get(`/invoices/parameters`)
                .then((response) => {
                    if (response.data.companies) {
                        invoiceCompanies.value = response.data.companies;
                    }
                    if (response.data.types) {
                        invoiceTypes.value = response.data.types;
                    }
                    if (response.data.statuses) {
                        invoiceStatuses.value = response.data.statuses;
                    }
                });
        };

        app.provide('invoiceCompanies', invoiceCompanies);
        app.provide('invoiceTypes', invoiceTypes);
        app.provide('invoiceStatuses', invoiceStatuses);

        app.provide('loadInvoicesParameters', loadInvoicesParameters);
    },
}
